export default "__VITE_PUBLIC_ASSET__21d101e5__"